import { inject, Injectable } from '@angular/core';
import { IrdFormatService } from '@ird/ng-core';
import { IrdEntitySchema, IrdProperty } from '@ird/shared-base';

@Injectable()
export class GenericAdminService<Dto> {
  private readonly formatService = inject(IrdFormatService);

  extractVisibleProperties(metadata: IrdEntitySchema<Dto>): Array<IrdProperty<unknown, unknown>> {
    return Object.values(metadata.properties).filter((item: IrdProperty<any, any>) => item.showInUi) as Array<
      IrdProperty<unknown, unknown>
    >;
  }

  getPropertyName(property: IrdProperty<any, any>): string {
    return property.name?.toString();
  }

  formatJson(input: any): string {
    if (input) {
      return JSON.stringify(input);
    } else {
      return '';
    }
  }

  /**
   * Through `IrdFormatService`, so a throwing parser reads as the empty marker instead of breaking
   * the view. A form field passes `''` as the marker; a cell keeps the default.
   */
  formatObject(dto: Dto, property: IrdProperty<any, any>, emptyMarker?: string): string {
    const parser = property.parser;
    return this.formatService.format(dto[property.nameAsString()], {
      type: property.type,
      format: parser ? { kind: 'custom', render: (value) => `${parser(value as never) ?? ''}` } : undefined,
      emptyMarker,
    });
  }
}
